import { feeCollectionSlice } from "./slice";

export const {
  addToPay,
  removeFromPay,
  updateTotalSumAndFine,
  resetFeeCollectionModalState,
} = feeCollectionSlice.actions;
